import React from 'react';
import { makeStyles } from '@mui/styles';
import { Typography, Tooltip } from '@mui/material';
import InfoRoundedIcon from '@mui/icons-material/InfoRounded';

const useStyles = makeStyles((theme) => ({
  titleContainer: {
    display: 'flex',
    alignItems: 'center',
    width: '200px',
  },
  infoIcon: {
    ...theme.globalClasses.infoRoundedIcon,
    fontSize: '20px',
  },
  unitBold: theme.globalClasses.unitBold,
}));

const NutrientItemTitle = ({ name, longDescription }) => {
  const classes = useStyles();

  return (
    <div className={classes.titleContainer}>
      {longDescription && (
        <Tooltip
          title={longDescription}
          arrow
          placement="top"
        >
          <InfoRoundedIcon className={classes.infoIcon} />
        </Tooltip>
      )}
      <Typography className={classes.unitBold}>{name}</Typography>
    </div>
  );
};

export default NutrientItemTitle;
